
import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import ZoomVideo from '@zoom/videosdk';
import { RouterModule } from '@angular/router';
import { MentoringEvents } from 'app/helpers/events';
import { VideoChatService } from 'app/messageServices/video-chat-service';
import { NgaModule } from 'app/theme/nga.module';
import { JoyrideModule } from 'ngx-joyride';
import { VideoCallsComponent } from 'app/pages/channelTopPanel/video-calls/video-calls.component';

declare global {
  interface Document {
    pictureInPictureElement: HTMLVideoElement | null;
    exitPictureInPicture: () => Promise<void>;
  }
}
@Component({
    selector: 'app-video-call-modal',
    templateUrl: './video-call-modal.component.html',
    styleUrls: ['./video-call-modal.component.scss'],
    imports: [NgaModule, RouterModule, JoyrideModule, VideoCallsComponent]
})
export class VideoCallModalComponent implements OnInit {
  @ViewChild('pipPlayer', { static: false }) pipPlayer!: ElementRef;
  @ViewChild('pipContainer', { static: false }) pipContainer!: ElementRef;




  showVideModalPopUp: any;
  isVideoLive: boolean = false;
  videoCallTrack: any;
  isDragging = false;
  initialX = 0;
  initialY = 0;
  isMuted = false;
  isVideoDisabled = false;
  zoomVideo = ZoomVideo.createClient()
  zoomSession: any

  constructor(private videoChatService: VideoChatService, private mentoringEvents: MentoringEvents,
    private renderer: Renderer2, private cdr: ChangeDetectorRef
  ) { }

  startDrag(event: MouseEvent): void {
    this.isDragging = true;
    this.initialX = event.clientX - this.pipContainer.nativeElement.offsetLeft;
    this.initialY = event.clientY - this.pipContainer.nativeElement.offsetTop;
  }

  @HostListener('document:mousemove', ['$event'])
  onDrag(event: MouseEvent): void {
    if (this.isDragging) {
      const newX = event.clientX - this.initialX;
      const newY = event.clientY - this.initialY;
      this.pipContainer.nativeElement.style.left = newX + 'px';
      this.pipContainer.nativeElement.style.top = newY + 'px';
    }
  }

  @HostListener('document:mouseup')
  stopDrag(): void {
    this.isDragging = false;
  }

  ngOnInit() {
    this.showVideModalPopUp = $('#showVideModalPopUp');
    this.showVideModalPopUp.modal('hide');
  }
  // onCloseVideo() {
  //   this.isVideoLive = false;
  // }

  ngAfterViewInit() {
    this.videoChatService.showVideoModalPopUp.subscribe(message => {
      if (message == true) {
        this.showVideModalPopUp.modal('show');
      }
    })
    this.mentoringEvents.getOpenVideoContainer().subscribe(item => {
      if (item) {
        this.isVideoLive = true;
      } else {
        this.isVideoLive = false;
      }
      // Ensure @if (isVideoLive) mounts app-video-calls without waiting for a click.
      this.cdr.detectChanges();
    });
    this.mentoringEvents.getOpenPipInWindow().subscribe(event => {
      const {value, data} = event; 
      const participantConnected = value;
      const handleElementStyling = (element) => {
        if (element) {
          element.style.zIndex = '2';
          element.style.width = '100%';
          element.style.height = '100%';
          element.style.left = '90%';
          element.style.top = '17px';
          element.style.backgroundColor = '#000';
          this.renderer.setStyle(this.pipContainer.nativeElement, 'display', 'block');
        }
      };

      if (participantConnected) {
        const roomParticipantElement = document.querySelector("#remote canvas");
        if (roomParticipantElement) {
          this.pipPlayer.nativeElement.appendChild(roomParticipantElement);
          const childElement = this.pipPlayer.nativeElement.querySelector('canvas');
          handleElementStyling(childElement);
          this.showVideModalPopUp.modal('hide');
        }
      } else {
        const localVideoElement = document.getElementById("zoom-local");
        if (localVideoElement) {
          this.pipPlayer.nativeElement.appendChild(localVideoElement);
          const childElement = this.pipPlayer.nativeElement.querySelector('video');
          handleElementStyling(childElement);



          this.showVideModalPopUp.modal('hide');
        }
      }
    });

    this.mentoringEvents.getVideoLiveRomm().subscribe(data => {
      if (data) {
        this.videoCallTrack = data
      }
      else {
        this.videoCallTrack = null
      }
    })
  }

  toggleRemotePictureInPicture() {
    const childElement = this.pipPlayer.nativeElement.querySelector('canvas') ? true : false
    this.mentoringEvents.setClosePipInWindow(childElement);
    this.renderer.setStyle(this.pipContainer.nativeElement, 'display', 'none');
    this.showVideModalPopUp.modal('show');
  }


}
